/*
===============================================================================
	File        =   ikimy-website-app/src/pages/Candidate/MobileCandidate.js
	Client      =   Rhealize
	Project     =   Ikimy Platform
	Purpose     =   Landing page for the MobileCandidate
				    
===============================================================================
	Revision History
		-----------------------------------------------------------------------
		Version Date        Author              Comments
		-----------------------------------------------------------------------
		1.0     2025.02.12  Moataz khallaf      Initial Creation
		1.1		2025.02.28	Daniel Rashidian	Moved nav bar and footer to App.js,
												Added links to buttons
		-----------------------------------------------------------------------
===============================================================================
*/
// react
import { useMemo } from "react";
// Assets
import guarantee from "../../assets/images/home/guarantee.jfif";
import ikimyHeroImage from "../../assets/images/home/hero.jfif";
import ctaCandidate from "../../assets/images/home/ctaCandidate.jfif";
import dona from "../../assets/images/home/dona.png";
import num01 from "../../assets/images/home/num01.png";
import num02 from "../../assets/images/home/num02.png";
import num03 from "../../assets/images/home/num03.png";

// ui-components
import {
	HeroMobile,
	ProcessMObile,
	GuaranteeMobile,
	YouGetMobile,
	FounderInsightMobile,
	CtaMobile,
} from "../../ui-components";

const CANDIDATE_APP = process.env.REACT_APP_CANDIDATE_APP;

const MobileCandidate = () => {
	const heroMobileOverrides = useMemo(() => {
		return {
			HeroMobile: {
				width: "100%",
				maxWidth: "100%",
				justifyContent: "center",
			},
			"Get Paid To\u2028Be Happy!": {
				children: `Get Paid To\nBe Happy!`
			},
			"ikimy hero image 1": {
				left: "0%",
				width: "100%",
				src: ikimyHeroImage,
				objectFit: "cover",
				objectPosition: "80%",
			},
			ButtonTesting: {
				style: {
					cursor: "pointer"
				},
				onClick: (event) => {
					window.open(`${CANDIDATE_APP}`, "_blank");
				}
			}
		};
	}, []);

	const processMobileOverrides = useMemo(() => {
		return {
			ProcessMObile: {
				width: "100%",
				maxWidth: "100%",
				justifyContent: "center",
			},
			"image 4": {
				src: num01,
			},
			"image 5": {
				src: num02,
			},
			"image 6": {
				src: num03,
			},
		};
	}, []);

	const guaranteeMobileOverrides = useMemo(() => {
		return {
			GuaranteeMobile: {
				width: "100%",
				maxWidth: "100%",
				justifyContent: "center",
				textAlign: "center",
				alignItems: "center",
			},
			"Frame 1160464750": {
				justifyContent: "center",
				textAlign: "center",
				alignItems: "center",
			},
			// duplicate and more complicated to work with
			// just leave deleted till we fix the figma file
			Item: {
				display: "none",
			},
			"Frame 1160464777": {
				position: "absolute",
				top: "60%",
				left: "3%",
				justifyContent: "center",
			},
			"Frame 1160464556743223692": {
				position: "absolute",
				top: "85%",
				left: "30%",
			},
			"AdobeStock_178517791 1": {
				src: guarantee,
				objectFit: "cover",
				objectPosition: "80%",
				position: "relative",
				justifyContent: "center",
			},
			ButtonTesting: {
				style: {
					cursor: "pointer"
				},
				onClick: (event) => {
					window.open(`${CANDIDATE_APP}`, "_blank");
				}
			},
			"Your enemy is an \u201CApplicant Tracking System,\u201D and just ONE wrong keyword in your application is all it takes rip a great job you deserve right out of your hands! Great system, eh?": {
				children: "Your enemy is an “Applicant Tracking System,” and just ONE wrong keyword in your application is all it takes to rip a great job you deserve right out of your hands! Great system, eh?"
			}
		};
	}, []);

	const youGetMobileOverrides = useMemo(() => {
		return {
			YouGetMobile: {
				width: "100%",
				maxWidth: "100%",
				justifyContent: "center",
			},
			"You land the interview!": {
				children: "You land an interview!"
			},
			"You Get the job!": {
				children: "You get a job you enjoy!"
			}
		};
	}, []);

	const founderInsightMobileOverrides = useMemo(() => {
		return {
			FounderInsightMobile: {
				width: "100%",
				maxWidth: "100%",
				justifyContent: "center",
			},
			"unsplash:6SlQ22nMzGs": {
				src: dona,
				objectFit: "cover",
				objectPosition: "35%",
			},
		};
	}, []);

	const ctaMobileOverrides = useMemo(() => {
		return {
			CtaMobile: {
				width: "100%",
				maxWidth: "100%",
				justifyContent: "center",
			},
			AdobeStock_272999282_Preview: {
				width: "100%",
				src: ctaCandidate,
				position: "static",
				objectFit: "cover",
				objectPosition: "55%",
			},
			ButtonTesting: {
				style: {
					cursor: "pointer"
				},
				onClick: (event) => {
					window.open(`${CANDIDATE_APP}`, "_blank");
				}
			}
		};
	}, []);

	return (
		<>
			<HeroMobile overrides={heroMobileOverrides} />
			<ProcessMObile overrides={processMobileOverrides} />
			<GuaranteeMobile overrides={guaranteeMobileOverrides} />
			<YouGetMobile overrides={youGetMobileOverrides} />
			<FounderInsightMobile overrides={founderInsightMobileOverrides} />
			<CtaMobile overrides={ctaMobileOverrides} />
		</>
	);
};

export default MobileCandidate;
